export class UrlUtil {
	public getEnvironment(src?: string) {
		const origin = src ? src : window.location.hostname;

		const environmentRegEx = /^(www\.)?(localhost|127.0.0.1|dev1|dev2|tst1|tst2|test1|test2|stage1|stage2)/;
		const environmentMatch = origin.match(environmentRegEx);

		return environmentMatch && environmentMatch[2] ? environmentMatch[2] : null;
	}

	public getUrlWithEnvironment(url: string, origin?: string) {
		const env = this.getEnvironment(origin);

		if (url[0] !== '/') {
			return 'https://www.' + (env ? env + '.' + url : url);
		}

		return url;
	}

	public getMappedUrl(urlMap: { [origin: string]: string }, defaultUrl: string, src?: string) {
		const internationalDomainRegEx = /\.(com)$|-(espanol)\.com$|\.([a-zA-Z]{2})$/;

		const origin = src ? src : window.location.hostname;

		const matches = origin.match(internationalDomainRegEx);

		if (!matches) {
			return null;
		}

		const match = urlMap[matches[1] || matches[2] || matches[3]];

		if (!match) {
			return this.getUrlWithEnvironment(defaultUrl, origin);
		}

		return this.getUrlWithEnvironment(match, origin);
	}
}
